import {OptionType} from 'presentation/components/Filter/types';
import {textHandle} from 'presentation/utils/textHandle';

const getFilteredOptions = (options: OptionType[], searchValue: string = '') => {
	if (!searchValue.trim()) return options;

	const normalizedSearch = textHandle(searchValue).sanitizeText();

	return options.filter(option =>
		textHandle(option?.label).sanitizeText().includes(normalizedSearch),
	);
};

export default getFilteredOptions;
